import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { MiscService } from '../shared/service/misc.service';
import {
  AlertDialogComponent,
  ConfirmDialogComponent,
  InputDialogComponent,
  LoadingDialogComponent
} from './component/alert';
import { ContactsPreviewComponent } from './component/contacts-preview/contacts-preview.component';
import { CountryMobileFieldComponent } from './component/country-mobile-field/country-mobile-field.component';
import { DefaultItemComponent } from './component/default-item/default-item.component';
import { FabComponent } from './component/fab/fab.component';
import { LoadingOverlayComponent } from './component/loading-overlay/loading-overlay.component';
import { RecipientsModalComponent } from './component/recipients/recipients-modal.component';
import { RecipientsComponent } from './component/recipients/recipients.component';
import { ResponsiveButtonsComponent } from './component/responsive-buttons/responsive-buttons.component';
import { SelectFieldComponent } from './component/select-field/select-field.component';
import { SenderRegisterComponent } from './component/sender-register/sender-register.component';
import { TextFieldComponent } from './component/text-field/text-field.component';
import { DragDropDirective } from './directive/drag-drop.directive';
import { MaskMsisdnPipe } from './pipe/mask-msisdn.pipe';
import { AuthGuard } from './guard';
import { AlertService } from './service/alert.service';
import { AuthService } from './service/auth.service';
import { ContactImportService } from './service/contact-import.service';
import { LoginService } from './service/login.service';
import { MessageService } from './service/message.service';
import { VCardService } from './service/vcard.service';
import { PaymentGatewayComponent } from './component/payment-gateway/payment-gateway.component';
import { CardButtonComponent } from './component/card-button/card-button.component';
import { Angular4PaystackModule } from 'angular4-paystack';
import { AppSettings } from './model';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    // BrowserAnimationsModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatListModule,
    MatBottomSheetModule,
    MatSelectModule,
    VirtualScrollerModule,
    Angular4PaystackModule.forRoot(AppSettings.PAYSTACK_PUBLIC_KEY),
  ],
  declarations: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    InputDialogComponent,
    LoadingDialogComponent,
    LoadingOverlayComponent,
    DefaultItemComponent,
    FabComponent,
    ResponsiveButtonsComponent,
    RecipientsComponent,
    RecipientsModalComponent,
    CountryMobileFieldComponent,
    TextFieldComponent,
    SelectFieldComponent,
    DragDropDirective,
    ContactsPreviewComponent,
    SenderRegisterComponent,
    MaskMsisdnPipe,
    PaymentGatewayComponent,
    CardButtonComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    AlertDialogComponent,
    ConfirmDialogComponent,
    InputDialogComponent,
    LoadingDialogComponent,
    LoadingOverlayComponent,
    DefaultItemComponent,
    FabComponent,
    ResponsiveButtonsComponent,
    RecipientsComponent,
    RecipientsModalComponent,
    CountryMobileFieldComponent,
    TextFieldComponent,
    SelectFieldComponent,
    DragDropDirective,
    ContactsPreviewComponent,
    SenderRegisterComponent,
    MaskMsisdnPipe,
    PaymentGatewayComponent,
    CardButtonComponent
  ],
  bootstrap: [LoadingDialogComponent],
  entryComponents: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    InputDialogComponent,
    RecipientsModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    MessageService,
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LoginService,
        AlertService,
        AuthService,
        AuthGuard,
        ContactImportService,
        VCardService,
        MiscService,
      ]
    };
  }
}
